import { greys, mainColors } from '../../../styling/theme';
import { Page, Section } from '../../../types/server-data/ClientConfig';
import { useSelector } from 'react-redux';
import {
  activePageSelector,
  activeSectionSelector,
} from '../../../redux/pages/selectors';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  link: {
    fontSize: '1.12rem',
    textDecoration: 'none',
    marginRight: '1.50rem',
    color: 'inherit',
    '& h2': {
      marginRight: '0.62rem',
    },
  },
  innerLink: {
    fontSize: '1.00rem',
    color: 'inherit',
  },
  navItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0.50rem',
    paddingRight: '1.50rem',
    paddingLeft: 0,
    color: greys.grey500,
    '&:hover': {
      color: greys.grey800,
    },
  },
  navItem__active: {
    color: mainColors.mainBlue,
    '&:hover': {
      color: mainColors.mainBlue,
    },
  },
  innerIcon: {
    fontSize: '1.00rem',
  },
  navItem__title: {
    fontSize: '0.88rem',
    marginLeft: '0.62rem',
  },
});

type NavPageProps = {
  page: Page;
  section: Section;
  handleShowing: () => void;
  Icon: any;
};

const NavPage: React.FC<NavPageProps> = ({
  Icon,
  page,
  section,
  handleShowing,
}) => {
  const classes = useStyles();

  const activePage = useSelector(activePageSelector);
  const activeSection = useSelector(activeSectionSelector);

  const [isPageActive, setIsPageActive] = useState<boolean>(false);

  useEffect(() => {
    setIsPageActive(
      activePage === page.pageKey && activeSection === section.sectionId,
    );
  }, [activePage, activeSection, page.pageKey, section.sectionId]);

  return (
    <Link
      onClick={handleShowing}
      to={'/' + section.sectionId + '/' + page.pageKey}
      key={page.pageKey}
      className={clsx(classes.link, classes.innerLink)}
    >
      <div
        className={
          isPageActive
            ? clsx(classes.navItem, classes.navItem__active)
            : classes.navItem
        }
      >
        <Icon className={classes.innerIcon} />
        <Typography variant="h5" className={classes.navItem__title}>
          {page.pageTitle}
        </Typography>
      </div>
    </Link>
  );
};

export default NavPage;
